import { PLATFORMS } from "../data/content";

export const Marquee = () => {
  const items = [...PLATFORMS, ...PLATFORMS];
  return (
    <div className="marquee relative border-y border-[var(--line)] py-6 overflow-hidden bg-[var(--bg-2)]" data-testid="platform-marquee">
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[var(--bg-2)] to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[var(--bg-2)] to-transparent z-10 pointer-events-none" />
      <div className="marquee-track">
        {items.map((p, i) => (
          <div key={i} className="flex items-center gap-10 px-5">
            <span className="font-display text-2xl sm:text-3xl font-light text-[var(--muted)] whitespace-nowrap">{p}</span>
            <span className="w-1.5 h-1.5 rotate-45 bg-[var(--gold)] shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
};
